import AntDesign from '@expo/vector-icons/AntDesign';
import { useCallback, useRef, useState } from 'react';
import { Dimensions, StyleSheet, TextInput, View } from 'react-native';
import { Text } from '@/components/Text';

import { Dropdown } from 'react-native-element-dropdown';
import { capitalizeWords, capitalizeEveryWord } from '@/utils/capitalize';
import colors from '@/config/colors';
import { useWordsetContext } from '@/hooks/useWordsetContext';
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import RadioButton from '@/components/ui/therapist/RadioButton';

const innerStyles = StyleSheet.create({
  input: {
    borderColor: 'gray',
    borderRadius: 1,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textInput: {
    width: Dimensions.get('screen').width / 3,
    height: 30,
    padding: 5,
    fontSize: 20,
    zIndex: 10,
    color: colors.newUI.therapist.textBlue100,
  },
  closeButtonParent: {
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 5,
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 3,
  },
  marginRight: {
    marginRight: 7.5,
  },
});

const termTypes = [
  {
    name: 'Wortsuche',
    value: 'word',
  },
  {
    name: 'Kategoriesuche',
    value: 'tag',
  },
];

export function SecondHeader() {
  const { term, termType, changeOuterState, tags } = useWordsetContext();
  const inputRef = useRef(null);
  const data = tags.map((tag) => {
    return {
      label: capitalizeEveryWord(tag),
      value: tag,
    };
  });
  const [isFocus, setIsFocus] = useState(false);
  const placeholder = termType == 'word' ? 'Wortsuche' : 'Kategoriesuche';

  const handleTermChange = useCallback((value) => {
    changeOuterState('term', capitalizeWords(value));
  }, []);

  const handleTermClear = useCallback(() => {
    handleTermChange('');
    inputRef.current?.clear();
  }, []);

  const handleTermTypeChange = useCallback((name, value) => {
    return () => {
      changeOuterState(name, value);
    };
  }, []);

  return (
    <View style={styles.secondHeader}>
      <Text style={[innerStyles.marginRight, styles.secondHeaderTitle]}>
        Wörter suchen
      </Text>
      {termType == 'word' ? (
        <View style={[innerStyles.input, innerStyles.marginRight]}>
          <TextInput
            ref={inputRef}
            defaultValue={term}
            placeholder={placeholder}
            placeholderTextColor={colors.newUI.therapist.grey70}
            style={innerStyles.textInput}
            allowFontScaling={false}
            onChangeText={handleTermChange}
          />
          <PressableNeolexon
            onPress={handleTermClear}
            style={innerStyles.closeButtonParent}
          >
            <AntDesign name="close" size={24} color={colors.darkGrey} />
          </PressableNeolexon>
        </View>
      ) : (
        <View style={styles.dropDownContainer}>
          <Dropdown
            style={[styles.dropdown, isFocus && { borderColor: 'blue' }]}
            placeholderStyle={styles.placeholderStyle}
            selectedTextStyle={styles.selectedTextStyle}
            inputSearchStyle={styles.inputSearchStyle}
            itemTextStyle={{ color: colors.newUI.therapist.textBlue100 }}
            iconStyle={styles.iconStyle}
            data={data}
            search
            mode={'auto'}
            placeholder={!term ? 'Kategorie auswählen' : term}
            searchPlaceholder="Kategoriesuche"
            value={term}
            labelField="label"
            valueField="value"
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            onChange={(item) => {
              handleTermChange(item.value);
              setIsFocus(false);
            }}
          />
        </View>
      )}
      <View style={innerStyles.radioContainer}>
        {termTypes.map((eachTermType) => {
          return (
            <View key={eachTermType.name} style={{ marginHorizontal: 16 }}>
              <RadioButton
                onPress={handleTermTypeChange('termType', eachTermType.value)}
                label={eachTermType.name}
                isSelected={termType === eachTermType.value}
                labelStyle={{ fontWeight: '600' }}
              />
            </View>
          );
        })}
      </View>
    </View>
  );
}
